import React, { ButtonHTMLAttributes } from 'react'

import * as S from './styles'

type Props = ButtonHTMLAttributes<HTMLButtonElement>

const SmallButton = ({ children, ...rest }: Props) => {
  return (
    <S.Wrapper>
      <button {...rest}>{children}</button>
    </S.Wrapper>
  )
}

export default SmallButton
